import React from 'react';
import nutriscoreA from '../assets/nutriscore/nutriscore-a.svg';
import nutriscoreE from '../assets/nutriscore/nutriscore-e.svg';
import ecoscoreAPlus from '../assets/ecoscore/green-score-a-plus.svg';
import ecoscoreC from '../assets/ecoscore/green-score-c.svg';
import ecoscoreD from '../assets/ecoscore/green-score-d.svg';
import novaGroup1 from '../assets/nova/nova-group-1.svg';
import novaGroup4 from '../assets/nova/nova-group-4.svg';
import saucePesto from '../assets/produits/sauce-pesto.jpg';
import nutellaBiscuit from '../assets/produits/nutella-biscuit.jpg';
import pateBio from '../assets/produits/pate-bio.jpg';

const HeroSection: React.FC = () => {
    return (
    <div id="hero-section" className="gradient-bg">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-24">
                <div className="lg:grid lg:grid-cols-2 lg:gap-8 items-center">
                    <div className="mb-12 lg:mb-0" data-aos="fade-right">
                        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                            Faites vos courses avec <br /> <span className="text-green-600">Le Panier Clair</span>
                        </h1>
                        <p className="text-lg text-gray-600 mb-8">
                            Votre extension navigateur qui affiche instantanément les notes NutriScore, NOVA et EcoScore pendant vos achats en ligne. Faites des choix plus sains et durables facilement.
                        </p>
                        <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                                <a href="#download-section" className="bg-green-600 text-white px-6 py-3 rounded-md font-medium hover:bg-green-700 transition text-center">
                                    Ajouter au navigateur - Gratuit
                                </a>
                                <a href="#how-it-works-section" className="bg-white text-green-600 px-6 py-3 rounded-md font-medium hover:bg-gray-50 transition text-center border border-gray-200">
                                    Comment ça marche
                                </a>
                        </div>
                    </div>
                    <div data-aos="fade-left">
                        <div className="bg-white p-6 rounded-xl shadow-lg">
                            <div className="flex items-center mb-4">
                                <img src={pateBio} alt="Produit" className="w-20 h-20 object-cover rounded-lg" />
                                <div className="ml-4">
                                    <h3 className="font-medium">Pâtes complètes bio</h3>
                                    <div className="flex mt-2 space-x-2">
                                        <img src={nutriscoreA} alt="NutriScore A" className="h-12" />
                                        <img src={ecoscoreAPlus} alt="EcoScore A+" className="h-12" />
                                        <img src={novaGroup1} alt="NOVA 1" className="h-12" />
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center mb-4">
                                <img src={nutellaBiscuit} alt="Produit" className="w-20 h-20 object-cover rounded-lg" />
                                <div className="ml-4">
                                    <h3 className="font-medium">Biscuits au chocolat</h3>
                                    <div className="flex mt-2 space-x-2">
                                        <img src={nutriscoreE} alt="NutriScore E" className="h-12" />
                                        <img src={ecoscoreD} alt="EcoScore D" className="h-12" />
                                        <img src={novaGroup4} alt="NOVA 4" className="h-12" />
                                    </div>
                                </div>
                            </div>
                            <div className="flex items-center">
                                <img src={saucePesto} alt="Produit" className="w-20 h-20 object-cover rounded-lg" />
                                <div className="ml-4">
                                    <h3 className="font-medium">Sauce pesto</h3>
                                    <div className="flex mt-2 space-x-2">
                                        <img src={nutriscoreE} alt="NutriScore E" className="h-12" />
                                        <img src={ecoscoreC} alt="EcoScore C" className="h-12" />
                                        <img src={novaGroup4} alt="NOVA 4" className="h-12" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;